// Catch-all voor onbekende én (feature-flag)-verborgen legacy routes.
// Voorbeelden: /ads, /shopify, /integraties/wordpress, tikfoutjes in de URL.
// Toont een B1-NL "Deze pagina bestaat niet"-scherm zodat er nooit een
// blanco pagina meer verschijnt.
import { Link } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import { Compass, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <AppLayout>
      <div
        data-testid="not-found-page"
        className="max-w-xl mx-auto mt-16 rounded-card border border-border-hairline bg-bg-panel p-8 text-center"
      >
        <Compass className="w-8 h-8 text-text-muted mx-auto mb-4" />
        <h1
          data-testid="not-found-title"
          className="text-xl font-display text-text-primary mb-3"
        >
          Deze pagina bestaat niet
        </h1>
        <p className="text-sm text-text-muted mb-5 leading-relaxed">
          Deze pagina hoort niet (meer) bij JustEasySEO. Ga terug naar je overzicht
          en kies een onderdeel uit het menu links.
        </p>
        <Link
          to="/"
          data-testid="not-found-back"
          className="inline-flex items-center gap-2 text-[11px] px-3 py-1.5 rounded border border-accent-teal/40 text-accent-teal hover:bg-accent-teal/10"
        >
          <ArrowLeft className="w-3 h-3" /> Terug naar dashboard
        </Link>
      </div>
    </AppLayout>
  );
}
